import React from 'react'
import { Button, Modal } from 'react-bootstrap';

const ModalRJCE = ({ toggleFunction, modalState }) => {
  // const formLink = 'https://forms.gle/qgWPeWUTKC1kC9v78'

  return (
    <Modal show={modalState} onHide={() => toggleFunction(false)} dialogClassName='custom-lg'>
      <Modal.Header closeButton>
        <Modal.Title></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <section className='info-container text-center'>
          <div className=''></div>
          <p className='heading-title fw-semibold mb-2'>Curso Sobre Patología y Colposcopia del Cuello Uterino</p>

          <p className='fw-semibold fs-int'>Tercera Cohorte</p>

          <p className='fw-semibold fs-int mb-4 mt-1'>Inscripciones Abiertas</p>

          <div className='info-group d-flex flex-column gap-3'>
            <div className='span-group'>
              <p className='fw-semibold mb-1'>Dirigido a: </p>

              <ul className='list-center unstyled-list centered mb-1'>
                <li>» Médicos Generales</li>
                <li>» Especialistas en Obstetricia y Ginecología</li>
                <li>» Residentes de la Especialidad</li>
              </ul>
            </div>

            <div className='span-group'>
              <span className='fw-semibold'>Carga Académica: </span>
              <span>220 horas</span>
            </div>

            <div className='span-group'>
              <span className='fw-semibold'>Modalidad: </span>
              <span>Presencial y Online</span>
            </div>


            <div className='span-group'>
              <span className='fw-semibold'>Duración: </span>
              <span>Seis (6) Meses</span>
            </div>

            <div className='span-group mb-2'>
              <span className='fw-semibold'>Fecha de Inicio: </span>
              <span>7 de noviembre de 2026</span>
            </div>

            {/* <Button className='link-button w-fit px-4 py-2 mx-auto my-1' target='blank' as='a' variant='primary' href={formLink}>
              Formulario de Inscripción
            </Button> */}
            
            <div className='info-group mt-2 mb-0'>
              <p className='fw-semibold mb-0'>Coordinador Académico: </p>
              <p className='fw-semibold'>Dr. José Núñez Troconis</p>
            </div>

            <div className='info-group d-flex flex-column align-items-center mb-2 gap-2'>
              <span className='fw-semibold'>Información: </span>
              
              <div className='d-flex'>
                <i className='bi bi-envelope-fill web-link me-2'></i>
                <a className='web-link' href="mailto:pecdepgfmluz@gmail.com">pecdepgfmluz@gmail.com</a>
              </div>
              <div className='d-flex'>
                <i className='bi bi-envelope-fill web-link me-2'></i>
                <a className='web-link' href="mailto:jtnunezt@gmail.com">jtnunezt@gmail.com</a>
              </div>
              <div className='d-flex'>
                <i className='bi bi-telegram web-link me-2'></i>
                <a className='web-link' href="https://t.me/depgfmluz">Telegram: Posgrado Medicina Universidad del Zulia</a>
              </div>
            </div>
          </div>
        </section>
      </Modal.Body>
      <Modal.Footer>
        <Button className='footer-button' variant="secondary" onClick={()=> toggleFunction(false)}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export { ModalRJCE }